import { useState, useEffect, useCallback } from 'react';
import { nightAuditService } from '../services/api';
import { toast } from 'react-toastify';

export const useNightAuditAdmin = () => {
  const [audits, setAudits] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState(null);

  // Load all audits
  const loadAudits = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await nightAuditService.getAllAudits();
      setAudits(data.audits || []);
    } catch (err) {
      console.error('Error loading audits:', err);
      setError(err.message || 'Failed to load audits');
      toast.error('Failed to load audit history');
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Delete audit by ID
  const deleteAudit = useCallback(async (auditId) => {
    try {
      setIsDeleting(true);
      await nightAuditService.deleteAudit(auditId);
      toast.success('Night audit deleted successfully');
      // Reload audits after deletion
      await loadAudits();
      return true;
    } catch (err) {
      console.error('Error deleting audit:', err);
      const errorMsg = err.error || err.message || 'Failed to delete audit';
      toast.error(errorMsg);
      return false;
    } finally {
      setIsDeleting(false);
    }
  }, [loadAudits]);

  // Load audits on mount
  useEffect(() => {
    loadAudits();
  }, [loadAudits]);

  return {
    audits,
    isLoading,
    isDeleting,
    error,
    loadAudits,
    deleteAudit,
  };
};
